import { CowmedLocalizationProvider } from '@chipinside/frontend'

import { useUserLocale } from '#/store/ducks/auth'

export function Localization({ children }: any) {
  const userLocale = useUserLocale()

  return <CowmedLocalizationProvider userLocale={userLocale}>{children}</CowmedLocalizationProvider>
}
